/* eslint-disable react/no-unused-state */
import { useTranslator } from '@bluebeam/react-i18n';
import { useAuth } from 'auth';
import BaseInput from 'components/inputs/BaseInput';
import Label from 'components/inputs/Label';
import OverlaySection from 'components/Overlays/OverlaySection/OverlaySection';
import debounce from 'lodash/debounce';
import React from 'react';
import { CreateRFI } from 'records/interactions/CreateRFI';
import { UpdateProject } from 'records/UpdateProject';
import { User } from 'records/User';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  interaction: CreateRFI;
}

const ProjectDetailsSection = (props: Props) => {
  const { userId } = useAuth();
  // eslint-disable-next-line react/sort-comp
  const updateProject = (nextUpdateProject: UpdateProject) => {
    const { actions } = props;

    actions.updateProject(nextUpdateProject);
  };

  const debouncedUpdateProject = debounce(updateProject, 500);

  const { translate } = useTranslator(['formLabels']);

  const updateProjectCode = (nextCode: string) => {
    const { appState } = props;

    const project = appState.getProject();

    const nextProject = project.set('code', nextCode);

    debouncedUpdateProject(nextProject.intoUpdateProject());
  };

  const { appState } = props;
  const { projects, selectedProject, users, roles } = appState;
  const currentUser = users.find((u) => userId === u.id);

  const isAdmin = currentUser ? roles.get(currentUser.id, new User()) : false;

  const project = projects.get(selectedProject);

  if (!project || !currentUser) {
    return null;
  }

  const address = `${project.street}, ${project.state} ${project.zipcode}`;

  return (
    <OverlaySection label={translate('formLabels:projectDetails')}>
      <div className="mb3">
        <Label label={translate('formLabels:projectName')} />
        <BaseInput
          id="create-rfi-overlay-project-name"
          className="w100"
          defaultValue={project.name}
          disabled
        />
      </div>

      <div className="mb3">
        <Label label={translate('formLabels:projectAddress')} />
        <BaseInput
          id="create-rfi-overlay-project-address"
          className="w100"
          defaultValue={address}
          disabled
        />
      </div>

      <div>
        <Label label={translate('formLabels:projectCode')} />
        <BaseInput
          id="create-rfi-overlay-project-code"
          className="w100"
          defaultValue={project.code}
          disabled={!isAdmin}
          onChange={(evt) => updateProjectCode(evt.target.value)}
        />
      </div>
    </OverlaySection>
  );
};

export default withAppStore<Props>(ProjectDetailsSection);
